import { proposalrequest } from '@mep/pae-commons';
import { Tag } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { PROPOSAL_SUBJECT_TYPE_APPEARANCE } from '@/modules/proposalRequest/contants/proposalRequest';

const { SUBJECT_TYPE_ENUM } = proposalrequest;

const ProposalRequestType = ({ type, full, className, icon, ...props }) => {
  const { t } = useTranslation('proposalRequest');
  if (!type) return null;

  if (!PROPOSAL_SUBJECT_TYPE_APPEARANCE[type])
    return (
      <Tag key={type}
        className={classNames('table-tag-item flex items-center justify-center', { 'w-full': full }, className, 'max-w-32 text-center')}>
        -
      </Tag>);

  return (
    <Tag
      color={PROPOSAL_SUBJECT_TYPE_APPEARANCE[type].color} key={type}
      className={classNames('table-tag-item', { 'w-full': full }, 'max-w-48 flex justify-center', className)} {...props}>
      <div className={'flex items-center truncate'}>
        {icon}
        <span className={'flex-grow truncate'}>{t(`types.${type}`)}</span>
      </div>
    </Tag>
  );
};

ProposalRequestType.propTypes = {
  className: PropTypes.string,
  full: PropTypes.bool,
  type: PropTypes.oneOf(SUBJECT_TYPE_ENUM),
  icon: PropTypes.any,
};

ProposalRequestType.defaultProps = {
  type: null
};

export default memo(ProposalRequestType);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} type this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderProposalRequestType = (type) => {
  return (
    <ProposalRequestType type={type}/>
  );
};
